<div class="area-select dropdown"
    [class.with-title]="isShowTitle">
    <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled">

        <small class="area-select-title" *ngIf="isShowTitle">
            Área
        </small>

        <span class="area-select-label">
            <i class="fas fa-layer-group"></i>
            <span *ngIf="area">
                {{area.nome}}
            </span>
            <span *ngIf="!area">
                {{nullLabelSelected}}
            </span>
        </span>

    </button>
    
    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <ng-template [ngIf]="isShowNull">

                    <a class="dropdown-item" 
                        [class.dropdown-item-select]="!idArea"
                        (click)="select(null)">
                        {{nullLabel}}
                    </a>
                    <div class="dropdown-divider"></div>
                </ng-template>

                <a *ngFor="let area of areas" 
                    class="dropdown-item"
                    [class.dropdown-item-select]="area.id == idArea"
                    (click)="select(area)">
                    {{area.nome}}
                </a>
            </div>
        </div>        
    </div>
</div>